<template>
  <div class="shop">
    <div class="top">
      <!-- <el-button size="small" type="primary" @click="exportWoods"
        >导出数据</el-button
      > -->
      <el-date-picker
        v-model="form.rank_time"
        type="date"
        style="width:136px;margin-right:10px;"
        value-format="yyyy-MM-dd"
        size="mini"
        placeholder="查询日期"
      >
      </el-date-picker>
      <el-button
        class="search"
        size="small"
        type="primary"
        @click="searchList"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="排行" prop="uid"></el-table-column>
      <el-table-column label="用户账号" prop="mobile"></el-table-column>
      <el-table-column label="今日获取红包数量" prop="sum_money_tlj"></el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import { redPacketRank } from '@/api/redpacket'
import { API_BASE_URL } from '@/config'
export default {
  components: {},
  data() {
    return {
      tableData: [],
      labelPosition: 'right',
      is_export: 0, //0非导出，1导出
      form: {
        page: 1,
        rank_time:''
      },
      total: 0
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    //获取列表数据
    async getList() {
      let is_export = this.is_export
      let rank_time = this.form.rank_time
      let url = `page=${
        this.form.page
      }&is_export=${is_export}&start_time=${rank_time}`
      let res = await redPacketRank(url)
      console.log(res)
      if (res.code === 10000) {
        if (this.is_export == 1) {
          this.is_export = 0
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
          )
          return
        } else {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      } else {
        this.is_export = 0
        this.$message.error(res.message)
      }
    },
    //导出
    exportWoods() {
      this.is_export = 1
      this.getList()
    },
    //搜索
    searchList() {
      this.is_export = 0
      this.form.page = 1
      this.getList()
    },
    
    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getList()
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .top{
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
